import { NgModule } from '@angular/core';
import { GlobalModule } from '@app/core/global.module';
import { DynamicFieldsModule } from '@app/modules/dynamic-fields/dynamic-fields.module';
import { ButtonModule } from '@components/button/modules/button.module';
import { AppDialogModule } from '@components/dialog/modules/app-dialog.module';
import { ImagePickerComponent } from '@components/image-picker/image-picker.component';
import { PanelToolsModule } from '@components/panel-tools/panel-tools.module';
import { FileUploadModule } from 'ng2-file-upload';
import { UserListDialogComponent } from '../component/user-list-dialog.component';

@NgModule({
    declarations: [UserListDialogComponent],
    imports: [
        GlobalModule,
        DynamicFieldsModule,
        FileUploadModule,
        AppDialogModule,
        PanelToolsModule,
        ButtonModule,
        ImagePickerComponent,
    ],
})
export class UserListDialogModule {}
